/** @format */

import React from "react";
import { Link } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";
import { FaPlay } from "react-icons/fa";
import { useEffect } from "react";

const Reels = () => {
  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    scrollToTop();
  }, []);
  const backToHome = () => {
    window.history.back();
  };
  const videoData = [
    {
      title: "Bitget",
      description: "Things Are Heating Up 🔥 DOTA2 Bali Major #shorts",
      posterUrl: "https://i.ytimg.com/vi/1DtHB4zeDyU/oar2.jpg",
      trailerUrl:
        "https://www.youtube.com/embed/1DtHB4zeDyU?autoplay=1&rel=0&controls=0&showinfo=0",
    },
    {
      title: "Bitget",
      description: "What Are Smart Contracts? #bitget #shorts",
      posterUrl: "https://i.ytimg.com/vi/hfnQPpai4KE/oar2.jpg",
      trailerUrl:
        "https://www.youtube.com/embed/hfnQPpai4KE?autoplay=1&rel=0&controls=0&showinfo=0",
    },
    {
      title: "Bitget",
      description: "What Is Dollar-Cost Averaging? DCA #bitget #shorts",
      posterUrl: "https://i.ytimg.com/vi/nPEXiFQ6FDI/oar2.jpg",
      trailerUrl:
        "https://www.youtube.com/embed/nPEXiFQ6FDI?autoplay=1&rel=0&controls=0&showinfo=0",
    },
    {
      title: "Aaron Jack",
      description:
        "Top 5 MOST LOVED Programming Languages #coding #programming",
      posterUrl: "https://i.ytimg.com/vi/ao4rONf5DkI/oar2.jpg",
      trailerUrl:
        "https://www.youtube.com/embed/ao4rONf5DkI?autoplay=1&rel=0&controls=0&showinfo=0",
    },
    {
      title: "Bitget",
      description: "4 Must-Read Computer Science Books 📚 #coding #programming",
      posterUrl: "https://i.ytimg.com/vi/_zwrG0k8Eq4/oar2.jpg",
      trailerUrl:
        "https://www.youtube.com/embed/_zwrG0k8Eq4?autoplay=1&rel=0&controls=0&showinfo=0",
    },
    {
      title: "ItsKeaton",
      description: "How to Use ChatGPT AI for Social Media Marketing",
      posterUrl: "https://i.ytimg.com/vi/G1H4eDq5_L4/oar2.jpg",
      trailerUrl:
        "https://www.youtube.com/embed/G1H4eDq5_L4?autoplay=1&rel=0&controls=0&showinfo=0",
    },
  ];

  return (
    <>
      <div className='container-fluid sec-bg2 pt-5'>
        <div className='carousel-container'>
          <div className='carousel'>
            <div className='slider  '>
              <div className='slide-content '>
                <h1 className='movie-title '>Reels</h1>
                <div className='header-btn   backIcon'>
                <a
                    onClick={backToHome}
                    className='btn-default btn-border btn-opacity'>
                    <BsArrowLeft className='fs-4 text-light mx-2' />
                    <span>Back to Home page</span>
                  </a>
              </div>
              </div>
            
            </div>
          </div>
        </div>
      </div>
      {/* cards */}
      <div className='container-fluid mb-5 pb-5'>
        <div className='row  '>
          {videoData.map((item, index) => {
            return (
              <div className='col-lg-3 ' key={index}>
                <span
                  id='single_image'
                  data-fancybox
                  data-type='iframe'
                  data-src={item.trailerUrl}>
                  <div
                    className='movie-card-reels'
                    style={{
                      backgroundImage: `url(${item.posterUrl})`,
                    }}>
                    <button
                      className='btn btn-outline movie-card__button'
                      type='button'>
                      <FaPlay className='btn-icon' /> Watch Now
                    </button>
                  </div>
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Reels;
